<template>
  <div class="gallery">
    <img
      v-for="(img, key) in images"
      :key="key"
      :id="key === 0 ? 'first-image' : ''"
      v-lazy="img"
    />
    <transition name="fade">
      <div v-if="isLoading" class="loading-screen">
        Loading...
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Gallery',

  props: {
    images: {
      required: true,
      type: Array,
    },
  },

  data() {
    return {
      maxWidth: 0,
      resizeTimeout: null,
      isLoading: true,
    };
  },

  mounted() {
    // Handle images loading
    this.$Lazyload.$on('loaded', ({ el }) => {
      // Since top image doesn't always load first,
      // Re-handle all existing images when first loads
      if (el.id === 'first-image') {
        this.$el.querySelectorAll('img').forEach((el) => {
          this.handleImageLoad(el);
        });
        this.isLoading = false;
        return;
      }
      this.handleImageLoad(el);
    });

    // Handle images loading on resized
    const resizeThrottler = () => {
      // ignore resize events as long as an actualResizeHandler execution is in the queue
      if ( !this.resizeTimeout ) {
        this.resizeTimeout = setTimeout(() => {
          this.resizeTimeout = null;

          this.$el.querySelectorAll('img').forEach((el) => {
            this.handleImageLoad(el);
          });
       
        // The actualResizeHandler will execute at a rate of 15fps
        }, 66);
      }
    };
    window.addEventListener('resize', resizeThrottler);
  },

  destroyed() {
    clearTimeout(this.resizeTimeout);
  },

  methods: {
    /**
     * Resize image max-widths to match top image width
     */
    handleImageLoad(el) {
      // Check width of first image
      if (el.id === 'first-image') {
        // set our other images max widths to the same width
        this.maxWidth = el.width;
      } else {
        if (this.maxWidth > 0) {
          el.style.maxWidth = `${this.maxWidth}px`;
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$padding: 32px;
$topBarHeight: 92px + 2px + $padding;

.gallery {
  position: relative;
  padding: $padding $padding 0;
  text-align: center;

  img {
    display: block;
    margin: auto;
    max-width: 100%;
    margin-bottom: $padding;

    &:first-of-type {
      max-height: calc(100vh - #{$topBarHeight + $padding});
    }

    @media (max-height: 500px) {
      &:first-of-type {
        max-height: calc(100vh - #{$topBarHeight});
      }
    }
  }
}

.loading-screen {
  position: fixed;
  top: $topBarHeight;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(25, 25, 25);
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in-out 0ms;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
